export default "__VITE_ASSET__ab690264__"